// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1bx0P","label":"Completed_label__1uB83"};